import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => ({
    headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
});

export const obtenerEmpleados = async () => {
    const res = await axios.get(
        `${API}/empleados/`,
        getAuthHeaders()
    );

    return Array.isArray(res.data)
        ? res.data
        : res.data.results || [];
};

export const obtenerPuestos = async () => {
    const res = await axios.get(
        `${API}/puestos/`,
        getAuthHeaders()
    );

    return Array.isArray(res.data)
        ? res.data
        : res.data.results || [];
};